export const NotFound = () => {
  return (
    <div style={{textAlign: 'center'}}>
      <p style={{fontWeight: 'bold'}}>Diese Umfrage wurde nicht gefunden.</p>
      <p>Bitte überprüfe den Link auf Fehler!</p>
    </div>
  );
}